<template>
    <van-popup v-model="visibleDialog" position="bottom" :round='true' @close='onClose' >
        <div class="full">
            <h3>满返抵扣</h3>
            <van-radio-group v-model="radio">
                <van-cell-group>
                    <van-cell title="使用抵扣" clickable @click="radio = '1'">
                    <template #right-icon>
                        <span class="price">-<sub>¥</sub>{{ rebatePrice }}</span><van-radio checked-color="#ff7a45" name="1" />
                    </template>
                    </van-cell>
                    <van-cell title="不使用" clickable @click="radio = '2'">
                    <template #right-icon>
                        <van-radio checked-color="#ff7a45" name="2" />
                    </template>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
            <div class="btn">
                <van-button color="#ff7a45" @click="onFull">提交</van-button>
            </div>
        </div>
    </van-popup>
</template>
<script>
export default {
    props: {
        visibleFull: {
            type: Boolean,
            default: false
        },
        rebatePrice: {
            type: Number,
            default: 0
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        visibleDialog: {
            get () {
                return this.visibleFull
            },
            set () {
                this.$emit('update:visibleFull')
            }
        }
    },
    data () {
        return {
            radio: '1'
        }
    },
    methods: {
        onClose () {
            this.$emit('update:visibleFull')
        },
        onFull () {
            this.$emit('onFull', this.radio)
        }
    }
}
</script>
<style lang="scss" scoped>
.full {
    background: #fff;
    h3 {
        text-align: center;
        line-height: 100px;
        font-size: 34px;
        color: #000;
    }
    .btn {
        padding: 32px;
    }
    .price {
        font-size: 30px;
        color: #ff7a45;
        padding-right: 20px;
        sub {
            margin-left: 8px;
        }
    }
}
/deep/ .van-button--normal {
    width: 100%;
    height: 64px;
    font-size: 28px;
    border-radius: 64px;
}
/deep/ .van-popup {
    background: #fff;
}
/deep/ .van-cell {
    line-height: normal;
    font-size: 32px;
    color: #000;
}
/deep/ .van-cell-group {
    padding: 0 24px;
}
/deep/ .van-radio__icon {
    font-size: 36px;
}
</style>